import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { baseURL } from "../../config";

const ListPip = () => {
  const [posts, setPosts] = useState({ inititatepip: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [isHR, setIsHR] = useState(false);
  const [isMGR, setIsMGR] = useState(false);

  const [isUser, setIsUser] = useState(false);
  const [currdate, setCurrDate] = useState(null);
  const role = localStorage.getItem("userrole");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mypip = searchParams.get("mypip");
  const id = localStorage.getItem("employeeid");
  let buttonClass = "";
  let rejectBtnClass = "";

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        let url = `${baseURL}/getpip`;
        if (role === "ROLE_USER" || mypip == "1") {
          let eid = localStorage.getItem("employeeid");
          url = `${baseURL}/getpip?eid=` + eid;
          setIsUser(true);
        }
        const { data } = await axios(url);
        console.log("Fetched data:", data);
        if (Array.isArray(data.inititatepip)) {
          setPosts({ inititatepip: data.inititatepip });
        } else {
          console.error("Data is not an array:", data);
        }
        if (role === "ROLE_HR") {
          setIsHR(true);
        } else {
          setIsHR(false);
        }
        if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
          setIsMGR(true);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.inititatepip.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const handleEmployeePIPApproval = async (inititatepipId) => {
    try {
      const response = await axios.get(
        `${baseURL}/emppipupdatestatus?pipid=` + inititatepipId
      );
      const data = response.data;
      if (response.status === 200) {
        alert("Employee PIP Status Updated");
        window.location.href = "/piptable";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handlePIPApproval = async (inititatepipId, status) => {
    try {
      const response = await axios.get(
        `${baseURL}/hrpipupdatestatus?pipid=` +
          inititatepipId +
          "&status=" +
          status +
          "&hr=" +
          id
      );
      const data = response.data;
      if (response.status === 200) {
        alert("PIP Status Updated");
        window.location.href = "/piptable";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handlePIPStattus = async (inititatepipId, status) => {
    try {
      const response = await axios.get(
        `${baseURL}/mgrpipupdatestatus?pipid=` +
          inititatepipId +
          "&status=" +
          status
      );
      const data = response.data;
      if (response.status === 200) {
        alert("Updated PIP Status to " + status);
        window.location.href = "/piptable";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleView = (issue) => {
    let currentDate = new Date();
    currentDate = formatDate(currentDate);
    setCurrDate(currentDate);

    setSelectedIssue(issue);
  };

  const handleClose = () => {
    setSelectedIssue(null);
  };
  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">PIP LISTING</h4>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Employee Id</th>
            <th>Employee Name</th>
            <th>Appraisal Year</th>
            <th>Date Of Initiated</th>
            <th>View</th>
            <th>Emp.Status</th>
            <th>HR. Status</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center">
                You don't have any PIP.
              </td>
            </tr>
          ) : (
            currentPosts.map((inititatepip, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{inititatepip.employeeid}</td>
                <td>{inititatepip.employeename}</td>
                <td>{inititatepip.periodforpip}</td>
                <td>{formatDate(inititatepip.dateinitiated)}</td>
                <td>
                  <ReactBootstrap.Button
                    className="badge bg-secondary  border-0 "
                    onClick={() => handleView(inititatepip)}
                  >
                    View
                  </ReactBootstrap.Button>
                </td>
                <td>
                  {isMGR ? null : inititatepip.employeestatus}

                  <div className="d-none">
                    {
                      (buttonClass =
                        inititatepip.pipstatus === "Approved"
                          ? "badge bg-warning ml-1 text-dark border-0" // Different style for approved status
                          : "badge bg-success ml-1 border-0")
                    }
                  </div>
                  <div className="d-none">
                    {
                      (rejectBtnClass =
                        inititatepip.pipstatus === "Rejected"
                          ? "badge bg-danger  ml-1 border-0" // Different style for approved status
                          : "badge bg-danger ml-1 border-0")
                    }
                  </div>

                  {isMGR ? (
                    <div>
                      <button
                        className={buttonClass}
                        type="button"
                        value="Open"
                        disabled={inititatepip.employeestatus === "Open"}
                        onClick={() =>
                          handlePIPStattus(inititatepip.id, "Open")
                        }
                      >
                        {inititatepip.employeestatus === "Open"
                          ? "Open"
                          : "Open"}
                      </button>
                      <button
                        className={rejectBtnClass}
                        type="button"
                        value="Closed"
                        disabled={inititatepip.employeestatus === "Closed"}
                        onClick={() =>
                          handlePIPStattus(inititatepip.id, "Closed")
                        }
                      >
                        {inititatepip.employeestatus === "Closed"
                          ? "Closed"
                          : "Close"}
                      </button>
                    </div>
                  ) : null}
                </td>
                <td className="text-center pb-3">
                  {" "}
                  {isMGR ? inititatepip.pipstatus : null}
                  {isHR ? (
                    <div>
                      <button
                        className={buttonClass}
                        value="Approve"
                        disabled={inititatepip.pipstatus === "Approved"}
                        onClick={() =>
                          handlePIPApproval(inititatepip.id, "Approved")
                        }
                      >
                        {inititatepip.pipstatus === "Approved"
                          ? "Approved"
                          : "Approve"}
                      </button>
                      <button
                        className={rejectBtnClass}
                        type="button"
                        value="Reject"
                        disabled={inititatepip.pipstatus === "Rejected"}
                        onClick={() =>
                          handlePIPApproval(inititatepip.id, "Rejected")
                        }
                      >
                        {inititatepip.pipstatus === "Rejected"
                          ? "Rejected"
                          : "Reject"}
                      </button>
                    </div>
                  ) : null}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </ReactBootstrap.Table>
      <ReactBootstrap.Modal
        className="modal-lg  modal-dialog-centered"
        show={selectedIssue !== null}
        onHide={handleClose}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            PIP: Issues and Corrective Actions for{" "}
            {selectedIssue && selectedIssue.employeename}{" "}
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          {selectedIssue && (
            <div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Issue</th>
                    <th>Corrective Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>{selectedIssue.issueone}</td>
                    <td>{selectedIssue.actionone}</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>{selectedIssue.issuetwo}</td>
                    <td>{selectedIssue.actiontwo}</td>
                  </tr>

                  {selectedIssue.issuethree ? (
                    <tr>
                      <td>3</td>
                      <td>{selectedIssue.issuethree}</td>
                      <td>{selectedIssue.actionthree}</td>
                    </tr>
                  ) : null}

                  {selectedIssue.issuefour ? (
                    <tr>
                      <td>4</td>
                      <td>{selectedIssue.issuefour}</td>
                      <td>{selectedIssue.actionfour}</td>
                    </tr>
                  ) : null}
                  {selectedIssue.issuefive ? (
                    <tr>
                      <td>5</td>
                      <td>{selectedIssue.issuefive}</td>
                      <td>{selectedIssue.actionfive}</td>
                    </tr>
                  ) : null}
                </tbody>
              </table>

              <table boder="1">
                <tbody>
                  <tr>
                    <td width="30%" valign="top">
                      {" "}
                      <b>Reviewed and Accepted by</b>
                      <table boder="1">
                        <tbody>
                          <tr>
                            <td></td>{" "}
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              Emp. Name:{" "}
                              {selectedIssue && selectedIssue.employeename}{" "}
                            </td>{" "}
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              Date:{" "}
                              {selectedIssue.empackdate &&
                                formatDate(selectedIssue.empackdate)}
                            </td>{" "}
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="30%" valign="top">
                      {" "}
                      <b>Review Completed by:</b>
                      <table boder="1">
                        <tbody>
                          <tr>
                            <td></td>{" "}
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              Manager Name:{" "}
                              {selectedIssue && selectedIssue.ManagerName}{" "}
                            </td>{" "}
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              Date:{" "}
                              {selectedIssue &&
                                formatDate(selectedIssue.dateinitiated)}{" "}
                            </td>{" "}
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="30%" valign="top">
                      {" "}
                      <b>Human Resource Dept.</b>
                      <table boder="1">
                        <tbody>
                          <tr>
                            <td></td>{" "}
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              HR Name:{" "}
                              {selectedIssue.HRName &&
                                selectedIssue.HRName}{" "}
                            </td>{" "}
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              Date:{" "}
                              {selectedIssue.HRApproveddate &&
                                formatDate(selectedIssue.HRApproveddate)}{" "}
                            </td>{" "}
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              {isUser ? (
                <input
                  disabled={selectedIssue.employeeacknowledged === "Yes"}
                  className=" bg-danger border-0 btn btn-primary"
                  type="button"
                  value="I Acknowledge this PIP"
                  onClick={() => handleEmployeePIPApproval(selectedIssue.id)}
                />
              ) : null}
            </div>
          )}
        </ReactBootstrap.Modal.Body>

        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button variant="secondary" onClick={handleClose}>
            Close
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.inititatepip.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default ListPip;
